<button
  *ngIf="!canShowWarningWithText"
  #errorsAndWarningsButton
  mat-icon-button
  class="mat-icon-action-button-lg-with-border"
  [class.invalid]="hasErrors()"
  [class.warning]="hasWarnings()"
  (click)="showAllErrorsAndWarnings($event)"
>
  <ng-container *ngIf="hasErrorsAndWarnings(); else noErrorsOrWarnings">
    <mat-icon svgIcon="error"></mat-icon>
  </ng-container>
  <ng-template #noErrorsOrWarnings>
    <ng-container *ngIf="hasErrors()">
      <mat-icon svgIcon="error"></mat-icon>
    </ng-container>
    <ng-container *ngIf="hasWarnings()">
      <mat-icon svgIcon="warning"></mat-icon>
    </ng-container>
  </ng-template>
</button>

<button
  *ngIf="canShowWarningWithText"
  #errorsAndWarningsButton
  mat-stroked-button
  [class.invalid]="hasErrors()"
  [class.warning]="hasWarnings()"
  [class.disable-events]="!canShowAllErrorsAndWarnings()"
  fxLayout="column"
  fxLayoutAlign="center start"
  (click)="showAllErrorsAndWarnings($event)"
>
  <div class="disable-events" fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
    <ng-container *ngIf="hasErrorsAndWarnings(); else noErrorsOrWarnings">
      <mat-icon svgIcon="error"></mat-icon>
      <span class="b1 font-weight-bold">{{ 'PRODUCTION_ORDER.ERRORS.MULTIPLE_ERRORS_AND_WARNINGS' | bmsTranslate }}</span>
    </ng-container>
    <ng-template #noErrorsOrWarnings>
      <ng-container *ngIf="hasErrors()">
        <mat-icon svgIcon="error"></mat-icon>
        <span class="b1 font-weight-bold">
          <ng-container *ngIf="hasMultipleErrors(); else noMultipleErrors">
            {{ 'PRODUCTION_ORDER.ERRORS.MULTIPLE_ERRORS' | bmsTranslate }}
          </ng-container>
          <ng-template #noMultipleErrors>
            <ng-container *ngIf="canShowTotalWidthTooLittle()">
              {{ 'PRODUCTION_ORDER.ERRORS.TOTAL_WIDTH_TOO_LITTLE' | bmsTranslate: {value: productionSchedule.errors.totalWidthTooLittle} }}
            </ng-container>
            <ng-container *ngIf="canShowTotalWidthTooBig()">
              {{ 'PRODUCTION_ORDER.ERRORS.TOTAL_WIDTH_TOO_BIG' | bmsTranslate: {value: productionSchedule.errors.totalWidthTooBig} }}
            </ng-container>
          </ng-template>
        </span>
      </ng-container>
      <ng-container *ngIf="hasWarnings()">
        <mat-icon svgIcon="warning"></mat-icon>
        <span class="b1 font-weight-bold">
          <ng-container *ngIf="canShowCurrentLossFromProductionSchedule()">
            {{ 'PRODUCTION_ORDER.WEAVE_PLAN.WARNINGS.CURRENT_LOSS_IN_PERCENT' | bmsTranslate: {currentLossInPercent: productionSchedule.warnings.totalLossInPercent} }}
          </ng-container>
        </span>
      </ng-container>
    </ng-template>
  </div>
</button>
